<div id="custom-popup" class="select-list-popup-wrapper" [ngClass]="popupClass">
  <div class="custom-popup-overflow" (click)="closePopup($event)"></div>
  <div class="custom-popup-wrapper">
    @if (reload || entries.length || searchValue) { <label for="select-list-search">Suchen</label> }
    @if (reload || entries.length || searchValue) { <input id="select-list-search" [(ngModel)]="searchValue" (input)="changeSearchValue($event.target.value)" type="text" placeholder="Suchen"> }
    @if (totalPages) {
      <ul class="custom-popup-scrollable">
        @for (item of entries; track item) {
          <li class="select-list-item"
             [class.active]="item === active"
             [class.checkbox-wrapper]="item.checkbox"
             (click)="selectItem(item)">
            @if (!checkbox) { <span class="item-select">{{ item }}</span> }
            @if ( checkbox) { <input  [id]="'input_' + item.id" type="checkbox" class="custom-checkbox blue big" [(ngModel)]="item.active"> }
            @if ( checkbox) { <label [for]="'input_' + item.id">{{ item.label }}</label> }
          </li>
        }
      </ul>
    }

    @if (entries && entries.length === 0) { <p>Keine Daten vorhanden</p> }
    @if (totalPages && totalPages > 1) { <pagination-secondary class="m-xs" [totalPages]="totalPages" [page]="page" (callback)="paginationHandler($event)"></pagination-secondary> }

    <div class="popup-btn-group">
      <button class="wide-btn green" (click)="closePopup()">OK</button>
    </div>
  </div>
</div>
